export default function (fieldKey, desc)
{
    return fieldKey + (desc ? '_DESC' : '_ASC')
}